export default __webpack_public_path__ + "static/abouthero-md-999742bfa536fcab38954a22c3065849.jpg";